// The current implementation supports only one pinned column on the left side
// and constantly pinned last column on the right side

export const isStickyLeft = (index: number, isFirstColumnPinned: boolean) =>
  index === 0 && isFirstColumnPinned;

export const isStickyRight = (index: number, columnsLength: number) => index === columnsLength - 1;
